import React, { FC, memo } from 'react';

const EmptyComponent: FC = () => {
  return <></>;
};

export default memo(EmptyComponent);



// WEBPACK FOOTER //
// ./src/shared/empty/EmptyComponent.tsx